<div class="rt-detail">
    @for (section of sections; track section.title) {
    <table class="rt-detail-table" [attr.aria-label]="section.title">
        <colgroup>
            <col class="rt-detail-key-col" />
            <col />
        </colgroup>
        <thead>
            <tr>
                <th colspan="2">{{ section.title }}</th>
            </tr>
        </thead>
        <tbody>
            @for (field of section.fields; track field.label) {
            <tr>
                <td class="rt-detail-key">{{ field.label }}</td>
                <td class="rt-detail-value" [class.mono]="field.mono">
                    {{ field.value === null || field.value === undefined || field.value === '' ? '—' : field.value }}
                </td>
            </tr>
            }
        </tbody>
    </table>
    } @if (actions.length) {
    <div class="rt-detail-block">
        <h3 class="rt-detail-block__title">Actions</h3>
        <div class="rt-detail__actions">
            @for (item of actions; track item.action) {
            <button
                type="button"
                class="rt-detail__action"
                [class.rt-detail__action--danger]="item.danger"
                id="RecordDetail{{ item.action }}"
                (click)="action.emit(item.action)"
            >
                {{ item.label }}
            </button>
            }
        </div>
    </div>
    }
</div>
